export default __webpack_public_path__ + "static/psoriazal-plus-kak-da-se-spravim-header-539c6813d3c05af519855e0a36bc5e16.jpg";